export const BG1 = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="64" height="64" transform='scale(4.5)' viewBox="0 0 2100.000000 444.000000"
            preserveAspectRatio="xMidYMid meet">
            <g transform="translate(14, 470) scale(0.1, -0.1)"
            fill="blue" stroke="none">
            <path d="M11054 4281 c-53 -32 -51 -41 10 -41 47 0 56 3 56 18 0 17 -18 42
            -29 42 -4 0 -20 -9 -37 -19z"/>
            <path d="M9540 4180 l0 -60 60 0 60 0 0 -60 0 -60 -915 0 -914 0 -3 -62 -3
            -63 -120 0 -120 0 -5 47 c-7 59 -17 69 -72 75 -44 5 -44 5 -56 -34 -22 -73
            -82 -100 -187 -83 -49 8 -67 17 -117 61 l-60 52 -62 -62 -62 -61 -362 0 -362
            0 0 -117 0 -117 58 57 58 57 247 0 247 0 0 -60 0 -60 -795 0 -795 0 0 60 0 60
            -185 0 -185 0 0 -44 c0 -68 -18 -76 -163 -76 -121 0 -157 -9 -188 -46 -25 -30
            -91 -74 -112 -74 -12 0 -38 12 -58 26 -43 30 -70 29 -84 -4 l-10 -22 -302 0
            -303 0 0 -60 0 -59 -354 -3 c-195 -2 -358 -7 -362 -11 -5 -5 -11 -32 -14 -60
            l-5 -52 -301 -5 -301 -5 -40 -28 c-22 -15 -52 -41 -68 -57 l-29 -30 -200 0
            c-182 0 -204 -2 -233 -20 -22 -13 -36 -32 -44 -60 l-12 -40 -181 0 -180 0 59
            -60 59 -60 -122 0 -122 0 0 -60 0 -60 185 0 c174 0 185 1 185 19 0 26 38 71
            60 71 22 0 60 -45 60 -71 0 -16 -8 -19 -55 -19 -30 0 -55 -4 -55 -9 0 -15 69
            -53 85 -47 8 3 17 17 21 31 l6 25 445 0 c487 0 487 0 518 60 26 50 17 53 -31
            11 -61 -54 -74 -53 -74 4 l0 45 203 0 202 0 -41 -20 c-22 -11 -58 -38 -79 -60
            l-39 -40 43 0 c56 0 98 21 151 75 24 25 53 45 64 45 18 0 18 -1 3 -18 -10 -11
            -17 -35 -17 -60 l0 -41 -63 -3 c-57 -3 -62 -5 -65 -27 -10 -66 -72 -101 -177
            -101 l-65 0 0 -42 c0 -24 -7 -49 -17 -60 -15 -17 -13 -18 57 -18 70 0 75 2
            126 41 71 55 142 80 242 87 66 4 82 8 82 21 1 14 2 14 11 -1 7 -13 23 -18 59
            -18 l50 0 0 60 0 60 125 0 c125 0 125 0 125 24 0 33 34 73 75 86 31 10 38 9
            68 -14 45 -34 84 -35 93 -1 6 25 7 25 112 25 l105 0 -34 -23 c-20 -13 -39 -37
            -45 -57 -8 -25 -20 -37 -40 -44 -16 -4 -60 -22 -99 -38 -175 -76 -191 -81
            -262 -86 -43 -3 -77 -10 -84 -18 -6 -7 -12 -32 -14 -56 l-3 -43 -83 -7 c-117
            -9 -174 -29 -250 -89 -36 -28 -40 -29 -156 -29 l-119 0 -59 -60 -59 -60 99 -1
            c82 0 96 -2 81 -12 -11 -7 -38 -28 -60 -48 -74 -65 -67 -64 -356 -67 -146 -1
            -276 -2 -289 -2 -29 0 -91 -60 -91 -89 0 -20 5 -21 81 -21 86 0 134 17 145 52
            9 28 24 21 24 -11 0 -17 6 -31 16 -35 9 -3 227 -6 484 -6 l469 0 57 40 c55 38
            135 70 176 70 17 0 19 -7 16 -57 l-3 -58 -62 -3 c-58 -3 -63 -5 -63 -25 0 -13
            -7 -33 -16 -46 -29 -40 -73 -51 -213 -51 l-129 0 -7 -29 c-3 -15 -20 -41 -36
            -57 l-30 -29 -152 -3 -153 -3 -57 60 c-31 33 -57 53 -57 46 0 -24 -30 -45 -64
            -45 -36 0 -56 -15 -56 -42 0 -17 -29 -18 -592 -18 -669 0 -634 3 -713 -79
            l-39 -41 67 0 c103 0 165 -36 170 -99 1 -20 6 -21 184 -21 l182 0 3 -62 3 -63
            121 -2 c112 -1 124 -3 159 -27 47 -32 62 -33 77 -1 l11 25 429 0 428 0 0 -55
            c0 -51 -2 -56 -28 -65 -53 -20 -71 -33 -87 -65 -22 -48 -19 -55 26 -55 65 0
            79 13 79 70 l0 50 63 0 63 0 59 60 59 59 243 3 c134 2 243 1 243 -2 0 -2 -26
            -30 -57 -62 l-57 -58 121 0 c121 0 121 0 127 -25 8 -33 45 -33 84 0 28 24 36
            25 151 25 107 0 122 2 127 17 15 50 31 68 61 71 27 3 34 -2 47 -27 9 -16 16
            -37 16 -46 0 -13 36 -15 307 -15 266 0 309 -2 324 -16 28 -25 89 -43 147 -44
            48 0 54 -3 70 -30 l17 -30 298 0 298 0 54 41 c77 58 139 79 235 79 l80 0 0
            -50 c0 -36 -5 -52 -17 -59 -13 -8 10 -10 84 -11 94 0 104 -2 132 -25 16 -15
            36 -42 43 -60 l12 -35 102 0 c57 0 113 4 127 9 13 5 48 32 79 60 54 50 57 51
            117 51 55 0 61 -2 61 -21 0 -32 18 -57 53 -76 30 -17 113 -18 1271 -23 l1240
            -5 -3 -58 c-1 -31 0 -57 3 -57 3 0 22 11 42 25 47 32 88 32 194 0 109 -33 130
            -32 166 6 29 31 74 59 93 59 6 0 34 -20 64 -43 39 -32 65 -45 97 -49 37 -5 42
            -4 26 5 -51 31 -90 102 -62 113 6 2 117 3 246 2 229 -3 235 -4 232 -23 -11
            -80 -52 -99 -222 -103 l-135 -4 -17 -38 c-9 -23 -30 -48 -50 -60 l-33 -20 900
            0 900 0 -48 -46 c-26 -25 -52 -42 -57 -39 -6 3 -10 -3 -10 -14 0 -21 -4 -21
            -246 -21 -237 0 -247 -1 -277 -22 -20 -14 -50 -23 -86 -26 -48 -3 -62 0 -94
            22 -35 24 -45 26 -155 26 -112 0 -118 -1 -127 -22 -14 -33 -50 -34 -90 -4 -29
            23 -43 26 -110 26 -78 0 -118 -13 -146 -46 -8 -10 -32 -30 -53 -46 l-39 -28
            281 0 282 0 0 -60 0 -60 -287 0 c-261 -1 -285 -2 -261 -16 28 -15 58 -61 58
            -89 0 -13 30 -15 245 -15 l245 0 0 -65 0 -65 59 0 58 0 5 51 c3 28 11 55 19
            60 20 12 106 21 169 17 l55 -3 3 -62 3 -63 102 0 c100 1 102 1 75 18 -28 17
            -58 67 -58 96 0 13 12 16 59 16 l59 0 14 -42 c9 -28 24 -50 47 -65 l34 -23
            -44 0 -43 0 39 -40 c50 -51 109 -80 163 -80 l42 0 0 60 0 60 -64 0 -64 0 -46
            51 c-25 28 -46 55 -46 59 0 5 21 11 48 15 l47 6 -3 55 c-3 45 -1 55 15 60 42
            13 81 36 123 74 25 22 60 43 78 46 l32 7 0 -62 0 -61 118 0 c117 0 119 0 130
            25 15 32 38 32 84 0 l37 -25 670 0 670 0 38 25 c44 31 77 29 81 -3 l4 -23 291
            4 292 3 160 55 160 54 795 5 c620 4 800 8 817 18 24 13 53 61 53 87 0 13 -41
            15 -347 15 -346 1 -348 1 -303 19 25 10 72 31 105 46 33 15 76 34 95 41 29 11
            -283 13 -1898 14 l-1933 0 3 63 3 62 1093 3 1094 2 56 -50 c31 -27 59 -47 63
            -43 4 5 9 26 11 48 l3 40 245 5 c135 3 246 7 248 8 2 1 30 27 62 58 57 55 60
            56 93 45 41 -14 73 -46 82 -83 l7 -28 118 0 c118 0 118 0 124 25 8 31 40 65
            61 65 23 0 55 -37 55 -65 0 -31 4 -31 38 0 15 14 56 40 92 58 l65 32 822 3
            823 2 0 60 0 60 241 0 241 0 38 -30 c20 -16 61 -42 91 -57 53 -27 58 -28 244
            -30 105 -1 183 0 175 3 -8 4 -64 29 -125 57 -100 46 -118 51 -197 55 -49 2
            -88 7 -88 11 0 4 13 14 29 24 32 19 71 23 71 7 0 -21 16 -9 27 20 7 19 24 36
            45 45 31 13 21 14 -134 15 l-168 0 0 60 0 60 200 0 c220 0 246 -5 274 -58 l15
            -27 1 30 c0 42 16 55 67 55 24 0 43 4 43 9 0 4 -25 32 -55 60 -30 29 -55 54
            -55 57 0 2 27 4 60 4 57 0 60 -1 60 -25 0 -33 47 -83 88 -94 l32 -10 0 65 0
            64 33 0 c59 0 81 -19 87 -75 5 -47 7 -50 36 -53 26 -3 36 3 53 26 12 17 21 35
            21 41 0 6 5 11 10 11 6 0 10 -18 10 -41 l0 -40 48 7 c26 3 51 10 55 14 5 4 11
            29 15 56 l7 49 24 -33 c14 -21 21 -42 19 -57 -5 -22 -3 -23 16 -13 12 6 42 30
            68 53 26 23 61 45 79 49 17 3 114 6 215 6 l184 0 0 60 0 60 368 0 368 0 59 60
            59 60 60 0 60 0 -59 60 -59 60 -63 0 -63 0 0 58 c0 32 2 61 5 64 19 18 85 -22
            111 -68 9 -16 11 -11 10 26 l-1 45 123 3 c113 2 127 5 162 28 43 28 69 26 77
            -6 10 -37 56 -25 119 30 32 28 75 55 96 62 l39 11 -2 115 c-1 111 -1 114 22
            126 33 16 34 36 4 80 l-25 38 45 50 c25 28 42 55 38 59 -4 4 -26 9 -47 11
            l-39 3 -1 60 -1 60 -55 -3 c-60 -3 -100 -25 -160 -87 -31 -32 -39 -35 -92 -35
            l-58 0 0 65 0 65 -60 0 -60 0 0 60 0 60 -125 0 -125 0 0 59 c0 57 -1 59 -30
            65 -37 7 -77 47 -85 87 -6 28 -8 29 -66 29 l-59 0 0 -60 c0 -65 -3 -67 -54
            -46 -39 16 -66 51 -66 83 0 23 -2 23 -124 23 l-124 0 -6 34 c-9 46 -52 81
            -110 89 -83 12 -104 30 -130 110 -4 14 -17 17 -66 17 l-60 0 0 50 c0 45 -3 52
            -26 60 -14 6 -68 10 -120 10 -78 0 -94 3 -94 15 0 26 -29 74 -53 87 -12 7 -60
            15 -107 18 l-85 5 0 57 1 58 -63 -62 c-63 -62 -63 -63 -63 -120 0 -57 0 -58
            -29 -58 -63 0 -94 -14 -150 -66 l-56 -53 180 -1 179 0 -59 60 -59 60 122 0
            c77 0 122 -4 122 -10 0 -47 -57 -110 -99 -110 -18 0 -20 -8 -23 -62 l-3 -63
            -130 -3 c-163 -3 -279 10 -314 36 -14 10 -31 34 -37 53 -14 40 -32 41 -107 2
            -53 -27 -73 -24 -123 13 -30 23 -37 24 -212 24 l-182 0 0 23 c0 57 -60 97
            -148 97 -72 0 -92 17 -92 78 l0 42 288 0 c219 1 282 3 267 12 -11 6 -42 31
            -69 55 -26 23 -54 43 -62 43 -8 0 -14 5 -14 11 0 6 9 8 23 4 18 -5 17 -3 -7
            14 -34 23 -55 56 -56 88 0 28 -103 120 -150 133 -19 5 -60 10 -92 10 -51 0
            -61 4 -108 43 -96 78 -90 77 -324 77 l-209 0 44 -29 c24 -16 57 -43 73 -60 29
            -30 32 -31 122 -31 130 0 148 -6 212 -65 44 -40 69 -55 110 -65 50 -12 192
            -95 192 -112 0 -4 -53 -8 -118 -8 l-118 0 -30 31 c-16 17 -47 44 -68 60 l-39
            29 -233 0 -234 0 -47 36 c-107 82 -127 87 -338 94 l-190 5 -115 55 -115 55
            -579 3 -579 3 -37 29 c-77 61 -138 84 -236 88 l-92 4 -6 -29 c-4 -17 -21 -43
            -37 -59 l-30 -29 -1007 -3 -1006 -2 -58 57 -58 57 0 -57 0 -57 -606 0 c-414 0
            -619 4 -650 11 -49 13 -94 57 -94 92 0 18 -8 13 -52 -30 -29 -29 -66 -57 -81
            -62 -16 -6 -101 -11 -190 -11 l-163 0 -59 61 c-56 57 -62 60 -97 56 -47 -6
            -113 -38 -172 -83 l-45 -34 -120 0 -121 0 0 60 0 60 -120 0 -120 0 0 -60z
            m-4650 -855 l0 -65 -202 0 c-194 0 -201 1 -185 18 10 10 17 31 17 45 0 29 9
            34 27 16 12 -12 60 8 82 35 11 13 37 16 137 16 l124 0 0 -65z m-2460 -200 c7
            -8 15 -35 18 -60 4 -36 2 -45 -11 -45 -14 0 -14 -3 -1 -27 7 -16 14 -43 14
            -60 l0 -33 -122 0 -123 1 29 25 c21 18 37 25 58 22 27 -4 28 -3 28 34 l0 38
            -42 0 -43 1 27 15 c28 15 58 61 58 89 0 21 92 21 110 0z m750 -45 l0 -60 -107
            0 -108 0 33 20 c30 18 41 35 56 83 4 14 17 17 66 17 l60 0 0 -60z m666 0 c-62
            -60 -63 -60 -122 -60 -60 0 -60 0 -119 -60 l-59 -60 -121 0 -120 1 39 34 c21
            19 82 57 135 84 53 27 116 65 141 85 l45 35 122 0 121 1 -62 -60z m-922 -22
            c8 -12 13 -25 10 -30 -3 -4 -51 -8 -107 -7 l-102 0 80 29 c99 35 100 35 119 8z
            m-1061 -189 l-63 -30 -40 22 c-22 13 -40 26 -40 31 0 4 46 8 103 7 l102 0 -62
            -30z m1437 -10 c0 -52 -15 -79 -43 -79 -12 0 -34 -7 -49 -14 l-28 -15 0 75 0
            74 60 0 60 0 0 -41z m-1830 -20 c0 -26 -2 -29 -15 -19 -16 13 -51 6 -77 -17
            -25 -23 -41 -12 -23 15 11 15 26 22 49 22 19 0 39 7 46 15 18 21 20 19 20 -16z
            m2688 -611 l-3 -63 -177 -3 c-106 -1 -178 1 -178 7 0 16 92 91 111 91 9 0 40
            -18 68 -40 l51 -40 0 48 c0 27 3 52 7 55 3 4 33 7 65 7 l59 0 -3 -62z m-373
            -28 c10 -32 -3 -40 -63 -40 l-57 1 35 29 c40 35 76 39 85 10z m15533 -214 l3
            -59 60 59 59 58 0 -62 0 -62 -41 0 c-65 0 -79 -13 -79 -70 l0 -50 -65 0 -65 0
            0 59 c0 59 -1 60 -34 71 -52 17 -99 81 -81 110 4 7 50 10 123 8 l117 -3 3 -59z
            m369 15 c1 -24 4 -46 7 -49 3 -3 33 18 65 46 l59 52 111 0 c61 0 111 -4 111
            -8 0 -4 -26 -33 -58 -65 l-58 -57 -135 0 c-125 0 -139 2 -170 23 -37 25 -64
            70 -55 93 4 11 20 14 63 12 l58 -3 2 -44z m-1967 -572 c0 -12 -78 -77 -112
            -95 -38 -20 -238 -34 -238 -17 0 6 26 34 58 64 l57 54 118 0 c64 0 117 -3 117
            -6z m-6680 -896 c31 -20 80 -65 80 -72 0 -3 -52 -6 -115 -6 -63 0 -115 3 -115
            7 0 13 93 88 109 88 9 0 28 -7 41 -17z"/>
            <path d="M17665 4060 c53 -54 64 -60 100 -60 22 0 51 -7 63 -16 19 -13 22 -13
            22 -1 0 8 -27 39 -59 69 -58 55 -89 68 -154 68 l-31 0 59 -60z"/>
            <path d="M17850 3897 c0 -10 8 -17 18 -17 9 0 13 4 7 8 -5 4 -13 11 -17 16 -5
            5 -8 2 -8 -7z"/>
            <path d="M5502 3813 l3 -58 120 0 120 0 3 58 3 57 -126 0 -126 0 3 -57z"/>
            <path d="M18135 3495 c22 -8 50 -27 62 -42 l23 -28 0 43 0 42 -62 0 -63 -1 40
            -14z"/>
            <path d="M1100 3080 l0 -60 -120 0 -120 0 0 -60 0 -60 120 0 c112 0 120 1 120
            19 0 29 47 80 83 90 l32 9 -35 2 -35 2 35 10 c19 6 89 28 155 49 66 21 138 43
            160 48 29 6 -21 9 -177 10 l-218 1 0 -60z"/>
            <path d="M616 2974 c-3 -9 -6 -29 -6 -45 0 -29 0 -29 63 -29 l62 1 -48 44
            c-54 49 -62 53 -71 29z"/>
            <path d="M204 2769 c-18 -5 -54 -29 -82 -54 -27 -25 -55 -45 -61 -45 -6 0 -11
            -4 -11 -8 0 -5 24 -7 53 -6 28 2 86 5 127 7 49 3 92 11 125 26 56 24 125 70
            125 81 0 10 -57 -3 -134 -30 -67 -23 -88 -20 -102 14 -8 20 -13 22 -40 15z"/>
            <path d="M490 2719 l0 -60 34 26 c22 17 55 29 88 34 57 8 87 21 108 45 11 14
            0 16 -109 16 l-121 0 0 -61z"/>
            <path d="M798 2760 c21 -13 40 -36 50 -61 l15 -39 21 19 c27 25 69 41 108 41
            32 0 98 34 98 51 0 5 -70 9 -162 9 l-163 0 33 -20z"/>
            <path d="M2258 2634 c-28 -15 -58 -61 -58 -89 0 -19 0 -19 50 1 40 16 70 54
            70 89 0 19 -27 19 -62 -1z"/>
            <path d="M1895 2470 l-59 -60 40 0 c54 0 71 16 79 73 3 26 5 47 3 47 -2 0 -30
            -27 -63 -60z"/>
            <path d="M1220 2405 c0 -3 6 -20 14 -39 16 -37 60 -76 87 -76 16 0 19 8 19 60
            l0 60 -60 0 c-33 0 -60 -2 -60 -5z"/>
            <path d="M1398 2023 c-28 -18 -48 -52 -48 -83 0 -19 8 -20 176 -20 l176 0 51
            45 c60 52 76 56 79 18 0 -16 1 -35 2 -43 1 -12 15 -15 61 -15 l60 0 3 58 3 57
            -268 0 c-232 0 -272 -3 -295 -17z"/>
            <path d="M871 1967 c-6 -6 -11 -19 -11 -29 0 -15 9 -18 57 -18 55 0 56 0 39
            19 -25 27 -71 42 -85 28z"/>
            <path d="M20478 1784 c66 -17 102 -36 147 -75 l35 -31 0 61 0 61 -117 -1 -118
            0 53 -15z"/>
            <path d="M856 1705 c-44 -14 -88 -25 -97 -25 -27 0 -31 -15 -11 -40 16 -20 21
            -21 43 -10 13 7 33 21 44 31 17 15 41 19 140 21 l120 3 -28 19 c-44 30 -119
            30 -211 1z"/>
            <path d="M2592 1174 c-17 -12 -22 -25 -22 -59 l0 -44 51 47 c28 26 62 52 77
            59 25 11 23 12 -28 13 -35 0 -64 -6 -78 -16z"/>
            <path d="M4335 1130 c57 -58 61 -60 110 -60 28 0 56 5 63 12 7 7 12 34 12 60
            l0 48 -122 0 -122 0 59 -60z"/>
            <path d="M4890 1180 c0 -29 32 -80 59 -94 43 -23 59 -20 66 13 6 29 33 59 70
            79 16 9 -3 11 -87 12 -68 0 -108 -4 -108 -10z"/>
            <path d="M18394 1106 c-64 -29 -50 -36 73 -36 l118 0 -35 22 c-43 26 -115 33
            -156 14z"/>
            <path d="M8115 921 c-16 -10 -41 -31 -55 -46 -14 -15 -36 -32 -50 -39 -20 -9
            22 -12 200 -14 l224 -2 61 60 60 60 -205 0 c-183 0 -208 -2 -235 -19z"/>
            <path d="M8560 880 l0 -60 60 0 60 0 0 60 0 60 -60 0 -60 0 0 -60z"/>
            <path d="M16260 845 c0 -23 4 -25 41 -25 l42 0 -37 25 c-20 14 -39 25 -41 25
            -3 0 -5 -11 -5 -25z"/>
            <path d="M8853 775 c27 -25 53 -45 58 -45 5 0 9 20 9 45 l0 45 -57 0 -58 -1
            48 -44z"/>
            <path d="M17305 797 c88 -30 218 -30 265 0 l35 23 -180 -1 -180 -1 60 -21z"/>
            <path d="M16327 639 c53 -54 64 -61 88 -55 39 10 85 59 85 90 l0 26 -117 0
            -118 0 62 -61z"/>
            <path d="M16570 693 c8 -3 65 -28 125 -56 l110 -52 152 -3 c149 -3 153 -3 190
            22 49 34 81 34 89 1 6 -23 11 -25 65 -25 66 0 71 8 43 61 -29 57 -48 59 -436
            58 -194 0 -346 -3 -338 -6z"/>
            <path d="M8800 520 l0 -60 370 0 369 0 37 25 c48 32 96 32 204 0 59 -18 107
            -25 165 -25 l81 0 59 60 59 60 -672 0 -672 0 0 -60z"/>
            </g>
            </svg>
    
    )
}